export const PRODUCT_ANIMATION_SOURCE = {
  ACTIVE_FRAME: "active-frame",
  CABLES: "cables",
};

export function setProductAnimationState(wrapper, source, state) {
  if (!wrapper) return;

  wrapper.dataset.productAnimationSource = source;
  wrapper.dataset.productAnimationState = state;
}

export function isProductAnimationSource(wrapper, source) {
  return wrapper?.dataset.productAnimationSource === source;
}
